export default {"src":"/_next/static/media/call.1ba1a849.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};